// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-title[data-v-7ade7284]{font-size:1.1rem;font-weight:600}.text-block[data-v-7ade7284]{border-left:3px solid #e9ecef;padding-left:1rem}.button-group[data-v-7ade7284]{display:flex;gap:.5rem}.feedback-content[data-v-7ade7284]{background-color:#f8f9ff;border:1px solid #e6e6ff;border-radius:6px;padding:1rem;margin-top:.5rem}", ""]);
// Exports
module.exports = exports;
